import styled, { css } from 'styled-components';

import { pxToRem } from 'utils/scss';

const calculateStyles = props => {
  let style;
  switch (props.variant) {
    case 'login':
      style = css`
        padding: ${pxToRem('16px')} ${pxToRem('32px')};
        border-radius: ${pxToRem('32px')};
        border: none;
        min-width: ${pxToRem('250px')};
        min-height: ${pxToRem('60px')};
        background: ${({ theme }) => theme.colors.white};
        color: ${({ theme }) => theme.colors.fucsia};
        font-family: ${({ theme }) => theme.fontset.opensans};
        font-weight: 700;
        line-height: 1.14;
        letter-spacing: ${pxToRem('1.4px')};
      `;
      break;
    case 'login-cancel':
      style = css`
        padding: ${pxToRem('16px')} ${pxToRem('32px')};
        border: none;
        min-width: ${pxToRem('250px')};
        min-height: ${pxToRem('60px')};
        background: transparent;
        color: ${({ theme }) => theme.colors.white};
        font-family: ${({ theme }) => theme.fontset.opensans};
        font-weight: 700;
        line-height: 1.14;
        letter-spacing: ${pxToRem('1.4px')};
      `;
      break;
    case 'cta':
      style = css`
        border-radius: ${pxToRem('50px')};
        border: ${pxToRem('1px')} solid ${({ theme }) => theme.colors.fucsia};
        background: transparent;
        color: ${({ theme }) => theme.colors.fucsia};
        font-weight: 700;
        letter-spacing: ${pxToRem('3px')};
        font-size: ${pxToRem('15px')};
        padding: ${pxToRem('3px')} ${pxToRem('20px')};
        min-width: ${pxToRem('250px')};
        min-height: ${pxToRem('60px')};
      `;
      break;
    case 'popupYes':
      style = css`
        padding: ${pxToRem('16px')} ${pxToRem('32px')};
        border-radius: ${pxToRem('27px')};
        border: none;
        background: ${({ theme }) => theme.colors.gradient.cta};
        color: ${({ theme }) => theme.colors.white};
        font-family: ${({ theme }) => theme.fontset.opensans};
        font-weight: 600;
        line-height: 1.14;
        letter-spacing: ${pxToRem('1.4px')};
        width: ${pxToRem('240px')};
        height: ${pxToRem('48px')};
      `;
      break;
    case 'popupYesLead':
      style = css`
        padding: ${pxToRem('16px')} ${pxToRem('32px')};
        border-radius: ${pxToRem('27px')};
        border: none;
        background: ${({ theme }) => theme.colors.gradient.cta};
        color: ${({ theme }) => theme.colors.white};
        font-family: ${({ theme }) => theme.fontset.opensans};
        font-weight: 600;
        line-height: 1.14;
        letter-spacing: ${pxToRem('1.4px')};
        width: ${pxToRem('174px')};
        height: ${pxToRem('48px')};
      `;
      break;
    case 'popupCancel':
      style = css`
        padding: ${pxToRem('16px')} ${pxToRem('32px')};
        border-radius: ${pxToRem('27px')};
        border: ${pxToRem('3px')} solid
          ${({ theme }) => theme.colors.statusGreen};
        background: transparent;
        color: ${({ theme }) => theme.colors.black};
        font-family: ${({ theme }) => theme.fontset.opensans};
        font-weight: 600;
        line-height: 1.14;
        letter-spacing: ${pxToRem('1.4px')};
        width: ${pxToRem('240px')};
        height: ${pxToRem('48px')};
      `;
      break;
    case 'popupCancelLead':
      style = css`
        padding: ${pxToRem('16px')} ${pxToRem('32px')};
        border-radius: ${pxToRem('27px')};
        border: ${pxToRem('3px')} solid
          ${({ theme }) => theme.colors.statusGreen};
        background: transparent;
        color: ${({ theme }) => theme.colors.black};
        font-family: ${({ theme }) => theme.fontset.opensans};
        font-weight: 600;
        line-height: 1.14;
        letter-spacing: ${pxToRem('1.4px')};
        width: ${pxToRem('174px')};
        height: ${pxToRem('48px')};
      `;
      break;
    case 'forgotpassword':
      style = css`
        border-radius: ${pxToRem('50px')};
        border: none;
        min-width: ${pxToRem('250px')};
        min-height: ${pxToRem('60px')};
        background: ${({ theme }) => theme.colors.white};
        color: ${({ theme }) => theme.colors.buttonTextColor};
        font-weight: 700;
        letter-spacing: ${pxToRem('3px')};
        font-weight: bold;
        font-size: ${pxToRem('17px')};
      `;
      break;
    case 'people-buttons':
      style = css`
        background: none;
        border-radius: ${pxToRem('50px')};
        min-width: ${props.buttonType === 'people_role_change'
          ? pxToRem('168px')
          : pxToRem('240px')};
        min-height: ${pxToRem('48px')};
        color: ${({ theme }) => theme.colors.black.six};
        border: ${pxToRem('2px')} solid
          ${({ theme }) => theme.colors.statusGreen};
        margin-left: ${pxToRem('8px')};

        font-weight: bold;
        font-stretch: normal;
        font-style: normal;
        line-height: 1.14;
        letter-spacing: ${pxToRem('1.4px')};
        text-align: center;
      `;
      break;
    case 'charger-button':
      style = css`
        background: none;
        border-radius: ${pxToRem('27px')};
        min-width: ${pxToRem('136px')};
        height: ${pxToRem('32px')};
        font-weight: 700;
        color: ${({ theme }) => theme.colors.black};
        border: ${pxToRem('2px')} solid
          ${({ theme }) => theme.colors.statusGreen};
        margin-left: ${pxToRem('8px')};
        padding: ${pxToRem('6px')} ${pxToRem('20px')};
        margin-left: ${pxToRem('32px')};
        display: flex;
        justify-content: center;
        align-items: center;

        @media ${({ theme }) => theme.device.tablet} {
          margin-left: ${pxToRem('8px')};
          min-width: auto;
        }
      `;
      break;
    case 'accept-button':
      style = css`
        min-width: ${props.buttonType === 'people_role_change'
          ? pxToRem('168px')
          : pxToRem('240px')};
        min-height: ${pxToRem('48px')};
        padding: ${pxToRem('16px')} ${pxToRem('32px')};
        border-radius: ${pxToRem('27px')};
        color: ${({ theme }) => theme.colors.white};
        background-image: linear-gradient(79deg, #00d7a3, #00d7ca 54%, #00d7a3);
        margin-left: ${pxToRem('10px')};
        border: none;

        font-weight: bold;
        font-family: OpenSans;
        font-stretch: normal;
        font-style: normal;
        line-height: 1.14;
        letter-spacing: ${pxToRem('1.4px')};
        text-align: center;

        :disabled {
          background-color: ${({ theme }) => theme.colors.fadedGray};
          color: ${({ theme }) => theme.colors.white};
          background-image: none;
          cursor: not-allowed;
        }
      `;
      break;
    case 'sb-charger-button':
      style = css`
        min-width: ${pxToRem('240px')};
        min-height: ${pxToRem('48px')};
        padding: ${pxToRem('16px')} ${pxToRem('32px')};
        border-radius: ${pxToRem('27px')};
        color: ${({ theme }) => theme.colors.white};
        background-image: linear-gradient(79deg, #00d7a3, #00d7ca 54%, #00d7a3);
        margin-left: ${pxToRem('10px')};
        border: none;

        font-weight: bold;
        line-height: 1.14;
        letter-spacing: ${pxToRem('1.4px')};

        :disabled {
          background-color: ${({ theme }) => theme.colors.fadedGray};
          color: ${({ theme }) => theme.colors.white};
          background-image: none;
        }
      `;
      break;
    case 'create-account-buttons':
      style = css`
        min-width: ${pxToRem('101px')};
        min-height: ${pxToRem('16px')};
        padding: ${pxToRem('4px')} ${pxToRem('12px')};
        border-radius: ${pxToRem('12px')};
        border: ${props.selected
          ? `solid ${pxToRem('1px')} ${props.theme.colors.blue.one}`
          : props.error
          ? `solid ${pxToRem('1px')} ${props.theme.colors.statusRed}`
          : `solid ${pxToRem('1px')} ${props.theme.colors.black.eight}`};
        background: ${props.theme.colors.white};
        margin-top: ${pxToRem('12px')};
        margin-right: ${pxToRem('10px')};
        font-family: ${({ theme }) => theme.fontset.opensans};
        font-size: ${pxToRem('10px')};
        font-weight: 600;
        font-stretch: normal;
        font-style: normal;
        line-height: 1.33;
        letter-spacing: ${pxToRem('1px')};

        display: flex;
        flex-direction: row;
        gap: ${pxToRem('10px')};
      `;
      break;
    case 'otp':
      style = css`
        padding: ${pxToRem('16px')} ${pxToRem('32px')};
        border-radius: ${pxToRem('27px')};
        border: none;
        min-width: ${pxToRem('215px')};
        min-height: ${pxToRem('40px')};
        background: ${({ theme }) => theme.colors.white};
        color: ${({ theme }) => theme.colors.fucsia};
        font-family: ${({ theme }) => theme.fontset.opensans};
        font-weight: 600;
        line-height: 1.14;
        letter-spacing: ${pxToRem('1.4px')};
      `;
      break;
    case 'changepassword':
      style = css`
        width: ${pxToRem('225px')};
        height: ${props.name === 'changeaccountpassword'
          ? pxToRem('40px')
          : pxToRem('32px')};
        border-radius: ${pxToRem('27px')};
        border: none;
        font-family: ${({ theme }) => theme.fontset.opensans};
        font-weight: 600;
        line-height: 1.14;
        letter-spacing: ${pxToRem('1.4px')};
        margin: ${pxToRem('20px')} auto;
        background: ${props.status
          ? props.theme.colors.fadedGray
          : props.theme.colors.gradient.cta};
        color: ${({ theme }) => theme.colors.white};

        :disabled {
          color: ${props.status
            ? props.theme.colors.white
            : props.theme.colors.grayText};
        }
      `;
      break;
    case 'changeaccountpassword':
      style = css`
        width: ${pxToRem('168px')};
        height: ${pxToRem('48px')};
        border-radius: ${pxToRem('27px')};
        border: none;
        font-family: ${({ theme }) => theme.fontset.opensans};
        font-weight: 600;
        line-height: 1.14;
        letter-spacing: ${pxToRem('1.4px')};
        margin: ${pxToRem('20px')} auto;
        align-items: center;
        justify-content: center;
        display: flex;
        background: ${({ theme }) => theme.colors.gradient.cta};
        color: ${({ theme }) => theme.colors.white};
      `;
      break;
    case 'changeRole':
      style = css`
        min-width: ${pxToRem('104px')};
        padding: ${pxToRem('12px')} ${pxToRem('24px')};
        border-radius: ${pxToRem('22px')};
        border: ${props.error
          ? `solid ${pxToRem('1px')} ${props.theme.colors.statusRed}`
          : props.selected
          ? `solid ${pxToRem('1px')} ${props.theme.colors.blue.one}`
          : `solid ${pxToRem('1px')} rgba(7, 11, 21, 0.16)`};
        height: ${pxToRem('44px')};
        margin-right: ${pxToRem('24px')};
        margin-bottom: ${pxToRem('24px')};
        font-family: 'OpenSans', sans-serif;
        font-weight: 600;
        font-stretch: normal;
        font-style: normal;
        line-height: 1.33;
        letter-spacing: normal;
        background-color: rgba(255, 255, 255, 0.56);
        display: inline-flex;
        align-items: center;
        text-transform: uppercase;
      `;
      break;
    case 'resendEmailButton':
      style = css`
        width: ${pxToRem('171px')};
        height: ${pxToRem('32px')};
        border-radius: ${pxToRem('27px')};
        background-image: ${({ theme }) => theme.colors.greenGradient};
        border: none;
        display: flex;
        align-items: center;
        justify-content: center;
      `;
      break;
    case 'changesites':
      style = css`
        width: ${pxToRem('112px')};
        height: ${pxToRem('32px')};
        border-radius: ${pxToRem('27px')};
        border: none;
        font-family: ${({ theme }) => theme.fontset.opensans};
        font-weight: 600;
        line-height: 1.14;
        letter-spacing: ${pxToRem('1.4px')};
        margin: ${pxToRem('20px')} auto;
        background: ${props.status
          ? props.theme.colors.fadedGray
          : props.theme.colors.gradient.cta};
        color: ${({ theme }) => theme.colors.white};

        :disabled {
          color: ${props.status
            ? props.theme.colors.white
            : props.theme.colors.grayText};
        }
      `;
      break;
    case 'rfid':
      style = css`
        width: ${pxToRem('182px')};
        height: ${pxToRem('48px')};
        border-radius: ${pxToRem('27px')};
        border: none;
        font-family: ${({ theme }) => theme.fontset.opensans};
        font-weight: 600;
        line-height: 1.14;
        letter-spacing: ${pxToRem('1.4px')};
        margin: ${pxToRem('20px')} auto;
        background: ${props.status
          ? props.theme.colors.fadedGray
          : props.theme.colors.gradient.cta};
        color: ${({ theme }) => theme.colors.white};

        :disabled {
          color: ${props.status
            ? props.theme.colors.white
            : props.theme.colors.grayText};
        }
      `;
      break;
    case 'editaccountdata':
      style = css`
        width: ${pxToRem('240px')};
        height: ${pxToRem('48px')};
        border-radius: ${pxToRem('27px')};
        border: none;
        font-family: ${({ theme }) => theme.fontset.opensans};
        font-weight: 600;
        line-height: 1.14;
        letter-spacing: ${pxToRem('1.4px')};
        margin: ${pxToRem('20px')} auto;
        background: ${props.status
          ? props.theme.colors.fadedGray
          : props.theme.colors.gradient.cta};
        color: ${({ theme }) => theme.colors.white};

        :disabled {
          color: ${props.status
            ? props.theme.colors.white
            : props.theme.colors.grayText};
        }
      `;
      break;
    default:
      break;
  }

  return style;
};

export const ButtonWrapper = styled.button`
  cursor: pointer;
  text-transform: uppercase;
  :disabled {
    opacity: ${props => (props.variant === 'accept-button' ? '0.3' : '0.8')};
    color: ${props => props.theme.colors.grayText};
  }
  font-family: 'OpenSans';
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: ${pxToRem('14px')};
  ${props => calculateStyles(props)};

  ${props =>
    props.noPadding &&
    css`
      padding: 0;
    `}
`;
